var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full overflow-y-hidden",attrs:{"id":"app"}},[_c('router-view'),(_vm.toastmessage)?_c('div',{staticClass:"toast"},[_vm._v(" "+_vm._s(_vm.toastmessage)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }